import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
/**
 * Who is getting in touch — the form's "Role" dropdown, in the order it offers
 * them. This is the visitor's own answer about themselves; it is not the form's
 * `intent`, and it is not a job title.
 */
export const CONTACT_AUDIENCES = [
    "Provider",
    "Physician",
    "Investor",
    "Patient or Caregiver",
    "Partner",
    "Press",
    "Other",
];
export const contactFormSchema = {
    componentId: "ContactForm",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "body",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Body",
            type: "textarea",
        },
        { key: "fields", label: "Field set (short / long)", type: "text" },
        { key: "intent", label: "Intent (general / compliance)", type: "text" },
        { key: "submitLabel", label: "Submit label", type: "text" },
    ],
    mediaSlots: [],
};
//# sourceMappingURL=contact-form.js.map